// extracted by mini-css-extract-plugin
export default {"section":"notifications_section__KlPDL","title":"notifications_title__lEUH4","wrapper":"notifications_wrapper__Hmzrv"};